import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDiverge = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		d: "M3.75 3.75C3.75 4.54565 4.06607 5.30871 4.62868 5.87132C5.19129 6.43393 5.95435 6.75 6.75 6.75C7.54565 6.75 8.30871 6.43393 8.87132 5.87132C9.43393 5.30871 9.75 4.54565 9.75 3.75C9.75 2.95435 9.43393 2.19129 8.87132 1.62868C8.30871 1.06607 7.54565 0.75 6.75 0.75C5.95435 0.75 5.19129 1.06607 4.62868 1.62868C4.06607 2.19129 3.75 2.95435 3.75 3.75Z",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M3.75 20.25C3.75 21.0456 4.06607 21.8087 4.62868 22.3713C5.19129 22.9339 5.95435 23.25 6.75 23.25C7.54565 23.25 8.30871 22.9339 8.87132 22.3713C9.43393 21.8087 9.75 21.0456 9.75 20.25C9.75 19.4544 9.43393 18.6913 8.87132 18.1287C8.30871 17.5661 7.54565 17.25 6.75 17.25C5.95435 17.25 5.19129 17.5661 4.62868 18.1287C4.06607 18.6913 3.75 19.4544 3.75 20.25Z",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.25 3.75C14.25 4.54565 14.5661 5.30871 15.1287 5.87132C15.6913 6.43393 16.4544 6.75 17.25 6.75C18.0456 6.75 18.8087 6.43393 19.3713 5.87132C19.9339 5.30871 20.25 4.54565 20.25 3.75C20.25 2.95435 19.9339 2.19129 19.3713 1.62868C18.8087 1.06607 18.0456 0.75 17.25 0.75C16.4544 0.75 15.6913 1.06607 15.1287 1.62868C14.5661 2.19129 14.25 2.95435 14.25 3.75Z",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.75 6.75V17.25",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.75 12.75H11.25C12.8413 12.75 14.3674 12.1179 15.4926 10.9926C16.6179 9.86742 17.25 8.3413 17.25 6.75",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}));
});
export default SvgDiverge;
